/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: inherit
 */
import React, { useMemo, useState } from 'react';
import { View } from 'react-native';
import { MasterFilterSheetModal } from '../../shared/filters/MasterFilterSheetModal';
import { ModalFilterSelectTrigger } from '../../shared/modals/ModalFilterSelectTrigger';

type SupplierOption = { id: string; name: string };

type Props = {
  suppliers: SupplierOption[];
  supplierId: string | null;
  onSupplierChange: (next: { id: string | null; name: string | null }) => void;
  disabled?: boolean;
};

export function PurchaseSupplierField({
  suppliers,
  supplierId,
  onSupplierChange,
  disabled = false,
}: Props) {
  const [sheetOpen, setSheetOpen] = useState(false);

  const valueLabel = useMemo(() => {
    if (!supplierId) return 'Ninguno';
    return suppliers.find((s) => s.id === supplierId)?.name ?? 'Proveedor';
  }, [supplierId, suppliers]);

  const options = useMemo(
    () => suppliers.map((s) => ({ id: s.id, name: s.name })),
    [suppliers],
  );

  return (
    <>
      <View testID="purchase-supplier-trigger">
        <ModalFilterSelectTrigger
          label="Proveedor"
          value={valueLabel}
          active={supplierId != null}
          onPress={() => {
            if (disabled) return;
            setSheetOpen(true);
          }}
          accessibilityLabel={`Proveedor, ${valueLabel}`}
        />
      </View>
      <MasterFilterSheetModal
        visible={sheetOpen}
        title="Proveedor"
        options={options}
        selectedId={supplierId}
        allOptionLabel="Ninguno"
        onSelect={(id) => {
          const name = id ? (suppliers.find((s) => s.id === id)?.name ?? null) : null;
          onSupplierChange({ id, name });
        }}
        onClose={() => setSheetOpen(false)}
      />
    </>
  );
}
